let initalState = {
  pages: [],
  pages_names: [],
  plc: [],
  channels: [],
  alarms: [],
  notifications: [],
  temp_email: "",
  temp_id: "",
  profile_infos: {
    name: "",
    surname: "",
    department: "",
    competence: "",
    company: "",
    phone: "",
    phone2: "",
    address: "",
    email2: "",
    roles: "",
    factory: "",
    company_img: "",
  },
  company_id: "",
  tag_list: [],
  tag_values: [],
  tag_ids: [],
  main_path: "",
  current_path: "",
  white_space_items: [],
  toolbox_items: [],
  render_toolbox_items: [],
  pop_up_widget: [],
  fetch_tag_value_control: true,
  sistem_izleme_control: false,
  energy_tags1: [],
  energy_tags2: [],
  energy_tags3: [],
  sıcak_su_sistem: [],
  vrf_tags: [],
  pumps_tags: [],
  booster_tags: [],
  fans_tags: [],
  vrf5_tags: [],
  vrfks_tags: [],
  vrfhacim_tags: [],

  vrf4_tags: [],
  vrf3_tags: [],
  vrf2_tags: [],
  booster_calis_dur_komut_list: [],
  vrf_komut_list: [],
  notis_last_id: "",
  dashboard_datas: [],
  water_storage: [],
  hidrofor_state: [],
  vrf_teras: [],
  misafir_oda: {
    misafir: 0,
    oda: 0,
    date: "",
  },
  external_trend_info: [],
  external_trend_info_cop: [],
  tags_for_trend_page: [],
  dynamicPageWS: [],
  users_list: [],
  groups_list: [],
  yetkilendirme_state: [],
  combine_trends: [],
  group_id: "",
  wp_temps_items: [],
  tesis: {  Akra: "" },
  cop: 0,
  profile_photo: "",
  totalizer_tags: [],
  companies_list: [],
  canvas_boyut_gecici: { w: 0, h: 0 },
  reactFlowList: [],
  widget_library: [],
  current_page_details: {},
  current_dyn_pageName: "",
  fetch_pages_control: false,
  alarms2:[],
  alarm_popup_control:false,
  ucer_id:0,
  temp_com_id:null,
  company_logo_url: null
};

export const ProjectReducer = (state = initalState, action) => {
  switch (action.type) {

    case "SET_TEMP_COM_ID":
      return{
        ...state,
        temp_com_id:action.payload
      }
    case "SET_COMPANY_LOGO_URL":
      return{
        ...state,
        company_logo_url:action.payload
      }
    case "ALARM_POPUP_CONTROL":
      return{
        ...state,
        alarm_popup_control:action.payload
      }
    case "SET_UCER_ID":
      return{
        ...state,
        ucer_id:action.payload
      }

    case "SET_FETCH_PAGES_CONTROL":
      return {
        ...state,
        fetch_pages_control: action.payload,
      };

    case "SET_CURRENT_DYN_PAGENAME":
      return {
        ...state,
        current_dyn_pageName: action.payload,
      };
    case "SET_ALARM2":
      return{
        ...state,
        alarms2:action.payload
      }

    case "SET_CURRENT_PAGE_DETAILS":
      return {
        ...state,
        current_page_details: action.payload,
      };

    case "SET_WIDGET_LIBRARY":
      return {
        ...state,
        widget_library: action.payload,
      };

    case "SET_REACTFLOWList":
      return {
        ...state,
        reactFlowList: action.payload,
      };

    case "SET_CANVAS_BOYUT":
      return {
        ...state,
        canvas_boyut_gecici: action.payload,
      };

    case "SET_COMPANIES_LIST":
      return {
        ...state,
        companies_list: action.payload,
      };

    case "SET_TOTALIZER_TAGS":
      return {
        ...state,
        totalizer_tags: action.payload,
      };
    case "SET_PROFILE_PHOTO":
      return {
        ...state,
        profile_photo: action.payload,
      };

    case "SET_TESİS": {
      return {
        ...state,
        tesis: action.payload,
      };
    }

    case "SET_WP_TEMP":
      return {
        ...state,
        wp_temps_items: action.payload,
      };
    case "SET_COP":
      return {
        ...state,
        cop: action.payload,
      };

    case "SET_GROUP_ID":
      return {
        ...state,
        group_id: action.payload,
      };

    case "SET_COMBINE_TRENDS":
      return {
        ...state,
        combine_trends: action.payload,
      };

    case "SET_YETKİLENDİRME":
      return {
        ...state,
        yetkilendirme_state: action.payload,
      };

    case "ADD_GROUP_ITEM":
      return {
        ...state,
        groups_list: [...state.groups_list, action.payload],
      };
    case "SET_GROUP_ITEM":
      return {
        ...state,
        groups_list: action.payload,
      };
    case "ADD_USER_ITEM":
      return {
        ...state,
        users_list: [...state.users_list, action.payload],
      };
    case "SET_USER_ITEM":
      return {
        ...state,
        users_list: action.payload,
      };
    case "SET_DYNAMICPAGEWS":
      return {
        dynamicPageWS: action.payload,
      };
    case "ADD_DYNAMICPAGEWS":
      return {
        dynamicPageWS: [...state.dynamicPageWS, action.payload],
      };
    case "DELETE_DYNAMICPAGEWS":
      const arr__ = state.dynamicPageWS.filter((i) => {
        return i.id !== action.id_;
      });

      return {
        dynamicPageWS: arr__,
      };

    case "SET_TAGS_FOR_TRENDS_PAGE": {
      return {
        ...state,
        tags_for_trend_page: action.payload,
      };
    }

    case "SET_EXTERNAL_TREND_INFO":
      return {
        ...state,
        external_trend_info: action.payload,
      };
    case "SET_EXTERNAL_TREND_INFO_COP":
      return {
        ...state,
        external_trend_info_cop: action.payload,
      };
    case "SET_MISAFIR_ODA":
      return {
        ...state,
        misafir_oda: action.payload,
      };
    case "SET_VRF_TERAS_TAGS":
      return {
        ...state,
        vrf_teras: action.payload,
      };
    case "SET_HIDROFOR_STATE":
      return {
        ...state,
        hidrofor_state: action.payload,
      };
    case "SET_WATER_STORAGE":
      return {
        ...state,
        water_storage: action.payload,
      };
    case "SET_DASHBOARD_DATA":
      return {
        ...state,
        dashboard_datas: action.payload,
      };
    case "SET_NOTIS_LAST":
      return {
        ...state,
        notis_last_id: action.payload,
      };
    case "SET_VRF_KOMUT_LIST":
      return {
        ...state,
        vrf_komut_list: action.payload,
      };
    case "SET_B_C_D_K_L":
      return {
        ...state,
        booster_calis_dur_komut_list: action.payload,
      };
    case "SET_VRF5_TAGS":
      return {
        ...state,
        vrf5_tags: action.payload,
      };
    case "SET_VRFKS_TAGS":
      return {
        ...state,
        vrfks_tags: action.payload,
      };
    case "SET_VRFHacim_TAGS":
      return {
        ...state,
        vrfhacim_tags: action.payload,
      };
    case "SET_VRF4_TAGS":
      return {
        ...state,
        vrf4_tags: action.payload,
      };
    case "SET_VRF3_TAGS":
      return {
        ...state,
        vrf3_tags: action.payload,
      };
    case "SET_VRF2_TAGS":
      return {
        ...state,
        vrf2_tags: action.payload,
      };
    case "SET_FANS_TAGS":
      return {
        ...state,
        fans_tags: action.payload,
      };
    case "SET_BOOSTER_TAGS":
      return {
        ...state,
        booster_tags: action.payload,
      };
    case "SET_PUMPS_TAGS":
      return {
        ...state,
        pumps_tags: action.payload,
      };
    case "SET_VRF_TAGS":
      return {
        ...state,
        vrf_tags: action.payload,
      };
    case "SET_SICAK_SU_SİSTEM":
      return {
        ...state,
        sıcak_su_sistem: action.payload,
      };

    case "SET_ENERGY_TAGS":
      return {
        ...state,
        energy_tags1: action.payload,
      };
    case "SET_ENERGY_TAGS2":
      return {
        ...state,
        energy_tags2: action.payload,
      };
    case "SET_ENERGY_TAGS3":
      return {
        ...state,
        energy_tags3: action.payload,
      };
    case "SET_TEMP_EMAIL":
      return {
        ...state,
        temp_email: action.payload,
      };
    case "SET_PAGES_NAMES":
      return {
        ...state,
        pages_names: action.payload,
      };
    case "CLEAR_TEMP_EMAIL":
      return {
        ...state,
        temp_email: "",
      };
    case "SET_WHITE_SPACE":
      return {
        ...state,
        white_space_items: action.payload,
      };
    case "REMOVE_render_toolbox_items":
      var newdata = state.render_toolbox_items.pop();
      console.log(newdata);
      return {
        ...state,
        render_toolbox_items: newdata,
      };
    case "SET_render_toolbox_items":
      return {
        ...state,
        render_toolbox_items: action.payload,
      };
    case "ADD_render_toolbox_items":
      return {
        ...state,
        render_toolbox_items: [
          ...state.render_toolbox_items,
          ...action.payload,
        ],
      };

    case "SET_toolbox":
      console.log(action.payload);
      return {
        ...state,
        toolbox_items: action.payload,
      };
    case "SET_PATH":
      return {
        ...state,
        current_path: action.payload,
      };
    case "ADD_PAGE":
      return {
        ...state,
        pages: [...state.pages, action.payload],
      };
    case "REMOVE_PAGE":
      const arr_ = state.pages.filter((i) => {
        return i.pageId !== action.id;
      });
      console.log(arr_);
      return {
        ...state,
        pages: arr_,
      };
    case "REMOVE_WIDGET":
      const arr_w = state.widget_library.filter((i) => {
        return i.widgetId !== action.id;
      });

      return {
        ...state,
        widget_library: arr_w,
      };
    case "ADD_PAGE_NAME":
      return {
        ...state,
        pages_names: [...state.pages_names, action.payload],
      };
    case "SET_PAGES":
      return {
        ...state,
        pages: action.payload,
      };
    case "ADD_PLC":
      return {
        ...state,
        plc: [...state.plc, action.payload],
      };
    case "REMOVE_PLC":
      let arr = state.plc.filter((i) => {
        return i.plcId !== action.id;
      });
      return {
        ...state,
        plc: arr,
      };
    case "SET_PLC":
      return {
        ...state,
        plc: action.payload,
      };
    case "EDIT_PLC":
      return {
        ...state,
        plc: state.plc.map((i) => {
          console.log(i);
          if (action.id === i.plcId) {
            return {
              ...i,
              ...action.payload,
            };
          } else {
            return i;
          }
        }),
      };
    case "ADD_CHANNEL":
      return {
        ...state,
        channels: [...state.channels, action.payload],
      };
    case "REMOVE_CHANNEL":
      let arr2 = state.channels.filter((i) => {
        return i.channelId !== action.id;
      });
      return {
        ...state,
        channels: arr2,
      };
    case "EDIT_CHANNEL":
      return {
        ...state,
        channels: state.channels.map((i) => {
          if (action.id === i.channelId) {
            return {
              ...i,
              ...action.payload,
            };
          } else {
            return i;
          }
        }),
      };
    case "SET_CHANNELS":
      return {
        ...state,
        channels: action.payload,
      };
    case "ADD_POINT":
      return {
        ...state,
        tag_list: [...state.tag_list, action.payload],
      };
    case "REMOVE_POINT":
      let arr3 = state.tag_list.filter((i) => {
        return i.tagId !== action.id;
      });
      return {
        ...state,
        tag_list: arr3,
      };
    case "EDIT_POINT":
      return {
        ...state,
        tag_list: state.tag_list.map((i) => {
          if (action.id === i.tagId) {
            console.log(i);
            return action.payload;
          } else {
            return i;
          }
        }),
      };
    case "SET_PROFILE_INFO":
      return {
        ...state,
        profile_infos: action.payload,
      };
    case "SET_COMPANY_ID":
      return {
        ...state,
        company_id: action.id,
      };
    case "CLEAR_CID":
      return {
        ...state,
        company_id: "",
      };
    case "SET_TAG_LIST":
      return {
        ...state,
        tag_list: action.payload,
      };
    case "SET_TAG_IDS":
      return {
        ...state,
        tag_ids: action.payload,
      };
    case "SET_TAG_VALUES":
      return {
        ...state,
        tag_values: action.payload,
      };
    case "SET_MAIN_PATH":
      return {
        ...state,
        main_path: action.path,
      };
    case "SET_ALARM":
      return {
        ...state,
        alarms: action.payload,
      };
    case "SET_UYARI":
      return {
        ...state,
        notifications: action.payload,
      };
    case "ADD_POP_UP_WIDGET":
      return {
        ...state,
        pop_up_widget: [...state.pop_up_widget, action.payload],
      };
    case "CLEAR_POP_UP_WIDGET":
      return {
        ...state,
        pop_up_widget: [],
      };
    case "SET_TEMP_ID":
      return {
        ...state,
        temp_id: action.payload,
      };
    case "SET_FETCH_TAG_VALUE_CONTROL":
      return {
        ...state,
        fetch_tag_value_control: action.control,
      };
    case "SET_SYSTEM_MON_CONTROL":
      return {
        ...state,
        sistem_izleme_control: action.payload,
      };
    default:
      return state;
  }
};
